import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadGeographyByIdFailed, loadGeographyByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* loadGeographyById(action) {
  try {
    const url = `${BACKEND_MDS_URL}/geography/geographies/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadGeographyByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadGeographyByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadGeographyByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
